"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Patient = void 0;
/**
 * This entity is a root level object. It represents a patient It is serialized in JSON and saved in the underlying icure-patient CouchDB database.
 */
const ModelHelper_1 = require("./ModelHelper");
class Patient {
    constructor(json) {
        Object.assign(this, json, json.picture ? { picture: ModelHelper_1.b64_2ab(json.picture) } : {});
    }
}
exports.Patient = Patient;
(function (Patient) {
    Patient.GenderEnum = {
        Male: 'male',
        Female: 'female',
        Indeterminate: 'indeterminate',
        Changed: 'changed',
        ChangedToMale: 'changedToMale',
        ChangedToFemale: 'changedToFemale',
        Unknown: 'unknown',
    };
    Patient.BirthSexEnum = {
        Male: 'male',
        Female: 'female',
        Indeterminate: 'indeterminate',
        Changed: 'changed',
        ChangedToMale: 'changedToMale',
        ChangedToFemale: 'changedToFemale',
        Unknown: 'unknown',
    };
    Patient.DeactivationReasonEnum = {
        Deceased: 'deceased',
        Moved: 'moved',
        OtherDoctor: 'other_doctor',
        Retired: 'retired',
        NoContact: 'no_contact',
        Unknown: 'unknown',
        None: 'none',
    };
    Patient.PersonalStatusEnum = {
        Single: 'single',
        InCouple: 'in_couple',
        Married: 'married',
        Separated: 'separated',
        Divorced: 'divorced',
        Divorcing: 'divorcing',
        Widowed: 'widowed',
        Widower: 'widower',
        Complicated: 'complicated',
        Unknown: 'unknown',
        Contract: 'contract',
        Other: 'other',
    };
})(Patient = exports.Patient || (exports.Patient = {}));
//# sourceMappingURL=Patient.js.map